import React, { useState } from 'react';
import styled from '@emotion/styled';

import SlickBar from 'components/SlickBar';
import ImageThumbnail from '../elements/ImageThumbnail';
import ImageModal from 'components/ImageModal';

import vw from 'styles/utils';

import imageData from 'data/image';

function ImageBar() {
  const [isShowModal, setIsShowModal] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  const handleClickCloseButton = () => {
    setIsShowModal(false);
  }

  const handleShowModal = (index) => {
    setImageSrc(imageData[index].src);
    setImageUrl(imageData[index].url)
    setIsShowModal(true);
  }

  return (
    <Root>
      <SlickBar
        icon={require('assets/images/icons/mountain.png')}
        title="國際基盤 FREE"
      >
        {
          imageData.map((image, index) => (
            <ImageThumbnail
              title={image.title}
              src={image.src}
              onClick={() => handleShowModal(index)}
              key={image.title}
            />
          ))
        }
      </SlickBar>
      <ImageModal
        show={isShowModal}
        srcUrl={imageSrc}
        url={imageUrl}
        onClickCloseButton={handleClickCloseButton}
      />
    </Root>
  )
}

const Root = styled.section`
  ${vw('margin-bottom', 30, 60)}
`;

export default ImageBar
